<template>
    <div>
        <navigation-bar Close/>
        <div class="transfer main">
            <category-content class="text-left pt-0">
                <ul>
                    <li class="date">{{endAtDate}}</li>
                    <li><h2 class="brand overflow-omitted">{{commodityName}}</h2></li>
                </ul>
            </category-content>
            <div>
                <category-header title="轉贈對象" class="mb-2">
                    <div slot="more" class="buttons" v-if="giftMethodList.indexOf('3') !== -1">
                        <el-button type="text" @click="gotoCamera" >
                            <img src="@/assets/images/qrcode.svg" alt="掃碼">
                        </el-button>
                    </div>
                </category-header>
                <div class="border-input d-flex">
                    <div v-if="destName" class="dest-img">
                        <el-image :src="destImg" fit="cover"/>
                    </div>
                    <el-input class="border-input border-0 m-0 flex-1 red"
                              placeholder="請輸入對方會員ID或電話號碼"
                              readonly v-model="destName"
                              @click.native="showTargetInputDialog('轉贈對象')"/>
                </div>
                <category-header title="轉贈數量">
                    <span slot="more" class="text">
                      可轉贈<span>{{$public.numberFormat(maxAvailableCount)}}</span>點
                    </span>
                </category-header>
                <el-radio-group class="ml-4 mt-3" v-model="giftOrderType" >
                    <el-radio :label="1">依最快到期</el-radio>
                    <el-radio :label="2">依最久日期</el-radio>
                </el-radio-group>
                <number-controller :params="numberControllerParams" @triggerEvent="numberControllerEvent"/>
                <div v-if="giftLimitType === 2 && giftIsLimitPoint" style="text-align: center;">最高可轉贈數量共{{$public.numberFormat(giftMaxPoint)}}點</div>
                <div v-else-if="giftLimitType === 3" style="text-align: center;">最多可轉贈{{$public.numberFormat(giftLimitCount)}}次共{{$public.numberFormat(giftLimitMaxPoint)}}點</div>
                <category-header title="備註欄" class="mb-2"/>
                <el-input
                        class="border-input"
                        placeholder="此備註欄位僅您本人可以查看"
                        type="textarea"
                        :rows="4"
                        v-model="remarks"></el-input>

                <category-header title="留言給對方" class="mb-2"/>
                <el-input
                        class="border-input"
                        placeholder="請輸入文字內容"
                        type="textarea"
                        :rows="4"
                        v-model="message"></el-input>
            </div>
            <div slot="footer" class="footer-button">
                <el-button @click="goBack" class="cancel" round>取消</el-button>
                <el-button type="primary" @click="onConfirmBtnClick" round>送出</el-button>
            </div>
            <loading
                    :active.sync=isLoading
                    :can-cancel="false"
                    :is-full-page="true">
            </loading>
            <target-input-dialog :value="isShowTargetInputDialog"
                                 :outerContent="dialogMsg"
                                 :isCancel="true"
                                 :isClearTarget="true"
                                 :appendToBody="isWeb"
                                 @result="onTargetInputDialogResult"/>
            <target-confirm-dialog :value="isShowTargetConfirmDialog"
                                   :icon="tmpImg"
                                   :outerContent="dialogMsg"
                                   :name="tmpName"
                                   :isCancel="true"
                                   :appendToBody="isWeb"
                                   @result="onTargetConfirmDialogResult"/>
            <comm-dialog :value="isShowDialog"
                         :outerContent="dialogMsg"
                         :mainContent="dialogMsgMain"
                         :icon="icons"
                         :isCancel="false"
                         :appendToBody="isWeb"
                         @result="onDialogResult"/>
        </div>
    </div>

</template>

<script>

    import * as constDefine from "@/store/constDefine";

    const goToList = 1;

    import {checkPhone, checkPassword} from "@/util/validators";
    import CategoryContent from '@/components/category/Content.vue'
    import CategoryHeader from '@/components/category/Header.vue';
    import CommDialog from '@/components/CommDialog.vue';
    import TargetInputDialog from "./components/TargetInputDialog";
    import TargetConfirmDialog from "./components/TargetConfirmDialog";
    import NumberController from "@/components/NumberController";

    export default {
        name: "TransferBonusPoints",
        props: {
            isWeb: Boolean,
            dataTokenWeb: {default: ''},
        },
        components: {
            CategoryContent,
            CategoryHeader,
            CommDialog,
            TargetInputDialog,
            TargetConfirmDialog,
            NumberController,
        },
        data() {
            return {
                dataToken: this.isWeb ? (this.dataTokenWeb.dataToken || "") : (this.$route.query.dataToken || ""),
                dataObject: {
                  "id": 0,
                },
                isShowDialog: false,
                //彈框大標
                dialogMsg: '',
                //彈框小標
                dialogMsgMain: '',
                //彈框圖示
                icons: require('@/assets/images/dialog_question.svg'),
                destToken: '',       //要轉贈的對象的 token
                transAmount: 1,      //轉贈數量
                maxAvailableCount: 1,      //最大可轉贈的數量
                commodityName: '',   //物品名稱
                endAtDate: '',     //到期日, yyyy-MM-dd
                destName: '',       //轉贈對象的名稱 (顯示用)
                destPhone: '',      //轉贈對象的手機號碼 或 userCode
                destImg: '',        //轉贈對象的頭像
                tmpName: '',        //暫存轉贈對象的名稱 (顯示用)
                tmpPhone: '',       //暫存轉贈對象的手機號碼 或 userCode
                tmpImg: '',         //暫存轉贈對象的頭像
                remarks: '',    //備註
                message: '',    //留言
                isLoading: false,     //是否顯示載入動畫
                dialogResult: 0,
                isShowTargetInputDialog: false,
                isShowTargetConfirmDialog: false,
                numberControllerParams: {
                  default: 1,
                  min: 1,
                  max: 1,
                },
                giftOrderType: 1,
                giftLimitType: 0,
                giftIsLimitPoint: false,
                giftMaxPoint: 0,
                giftLimitCount: 0,
                giftLimitMaxPoint: 0,
                giftMethodList: [],
            }
        },
        created() {
          try {
            this.dataObject = this.$crypto.uriComponentToObject(this.dataToken);
            if(this.dataObject.usedType === this.$route.name || this.$route.name ==='WebStoreRewardPoint') {
              //讀取掃描結果
              let scanResult = sessionStorage.getItem('cameraResult');
              if (scanResult !== null && scanResult !== '') {
                //讀取完要清除，要再取得結果就要重新掃描
                sessionStorage.setItem('cameraResult', '');
                this.onScanResult(scanResult);
              }
              this.setupData();
            } else {
                if(!this.isWeb){
                    this.$router.push({name:'Error'});
                }else {
                    //單店網頁版用
                    this.$emit('close',false);
                }
              return false;
            }
          } catch (e) {
              if(!this.isWeb){
                  this.$router.push({name:'Error'});
              }else {
                  //單店網頁版用
                  this.$emit('close',false);
              }
            return false;
          }
        },
        methods: {

            /** 流程 : 輸入電話，代號或是掃描，都會取得對方 userCode，
             * 再將 userCode 填入框中，統一用 userCode 來當轉贈對象 */

            /** 開啓相機 */
            gotoCamera: function () {
                this.$router.push({name: `ScanCode`});
            },

            /** 接收掃描結果 */
            onScanResult: function (value) {
                if (/vcard/g.test(value.toLowerCase())) {
                    this.showDialog("請用本 app 的個人條碼來掃描");
                } else {
                    // this.destToken = value;
                    //解析 token
                    let decodeToken = this.$crypto.decryptText(value);
                    let decodeAry = decodeToken.split(';');
                    if (decodeAry !== undefined && decodeAry.length > 0) {
                        let userId = decodeAry[0];
                        this.doTargetConfirm(userId, '', '');
                    } else {
                        this.showDialog("掃描錯誤，請確認是否爲本 app 產生的 QRcode");
                    }
                }
            },

            /** 顯示 dialog */
            showDialog: function (msg) {
                this.dialogMsg = msg;
                this.isShowDialog = true;
            },

            /** dialog事件 返回 */
            onDialogResult: function () {
                this.isShowDialog = false;
                this.dialogMsgMain = "";
                if (this.dialogResult === goToList) {
                  this.dialogResult = 0;
                    if(!this.isWeb){
                        this.$router.push({name: 'Gift', params:{activeCategory: 'rewardPoint'}});
                    }else {
                        //單店網頁版用
                        this.$emit('close', true);
                    }
                }
            },

            /** 顯示 輸入轉贈對象 dialog */
            showTargetInputDialog: function (msg) {
                if(this.giftMethodList.indexOf('1') !== -1) {
                    this.dialogMsg = msg;
                    this.isShowTargetInputDialog = true;
                } else {
                    this.showDialog(`未開放手機號碼轉贈`);
                }
            },

            /** 輸入轉贈對象dialog事件 返回 */
            onTargetInputDialogResult: function (result, type, target) {
                this.isShowTargetInputDialog = false;
                if (result) {
                    if (checkPhone(target)) {
                        this.doTargetConfirm('', target, '');

                    } else {
                        this.doTargetConfirm('', '', target);
                    }
                }
            },

            /** 顯示 確認轉贈對象 dialog */
            showTargetConfirmDialog: function () {
                this.dialogMsg = '確認對象';
                this.isShowTargetConfirmDialog = true;
            },

            /** 確認轉贈對象dialog事件 返回 */
            onTargetConfirmDialogResult: function (result, type) {
                this.isShowTargetConfirmDialog = false;
                if (result) {
                  this.destName = this.tmpName;
                  this.destPhone = this.tmpPhone;
                  this.destImg = this.tmpImg;
                }
            },

            /** 確定轉贈 */
            onConfirmBtnClick: function () {

                if(this.destPhone === "" && this.destToken === "") {
                  this.showDialog('請輸入轉贈對象');
                } else if (isNaN(this.transAmount) || this.transAmount <= 0 || this.transAmount > this.maxAvailableCount) {
                  this.showDialog(`轉贈數量錯誤`);
                } else {
                  this.callGiftRewardPointApi()
                 }
            },

            /** 轉移紅利點數 */
            callGiftRewardPointApi() {
                this.isLoading = true;

                this.$http.fetchWithAuthEncrypt`GiftRewardPoint${{
                    id: this.dataObject.id,
                    amount: Number(this.transAmount),
                    userToken: this.destToken,
                    toUserCode: this.destPhone,
                    myselfNote: this.remarks,
                    toUserNote: this.message,
                    giftOrderType: this.giftOrderType,
                }}
                ${json => {
                    if (json.status) {
                        this.showDialog(`轉贈點數成功`);
                        this.dialogMsgMain = `剩餘數量<span class="red">${json.rewardPointUserPoint}</span>點`
                        this.icons= require('@/assets/images/dialog_ticket.svg')
                        this.dialogResult = goToList;
                    } else {
                        this.showDialog(json.message);
                    }
                    this.isLoading = false;
                }}`;
            },

            setupData() {
                this.$http.fetchWithAuthEncrypt`GetMyselfRewardPointInfo${{
                    "id": this.dataObject.id,
                }}
                 ${json => {
                    if (json.status && json.data.id > 0) {
                        let data = json.data;
                        this.commodityName = data.name;
                        this.giftMethodList = data.giftMethodList;
                        this.endAtDate = data.activityEnd;
                        this.maxAvailableCount = data.rewardPointUserPoint;
                        this.numberControllerParams.max = this.maxAvailableCount;
                        this.giftLimitType = data.giftLimitType;
                        this.giftIsLimitPoint = data.giftIsLimitPoint;
                        this.giftMaxPoint = data.giftMaxPoint;
                        this.giftLimitCount = data.giftLimitCount;
                        this.giftLimitMaxPoint = data.giftLimitMaxPoint;

                        if (this.maxAvailableCount === 0) {
                          this.showDialog('目前沒有可以轉贈的點數');
                        }
                    } else {
                      this.$public.showNotify(json.message, false);
                    }
                }
                }}`;
            },

            /** 確認轉贈對象 */
            doTargetConfirm: function (userId, userPhone, userCode) {
                if(userId === '' && userPhone === '' && userCode === '') {
                    this.showDialog('請輸入對方會員ID或電話號碼');
                    return false
                }

                this.callGetOtherUserInfoApi(userId, userPhone, userCode)
                    .then( this.showTargetConfirmDialog )
                    .catch( (error) => {
                        this.isLoading = false;
                        this.showDialog(error);
                        // self.$store.commit(mutationTypes.SHOW_TOAST, error);
                    });
            },

            /** 查轉贈對象資訊，任一條件有就尋找，最好只輸入其中一項資料 */
            callGetOtherUserInfoApi: function (userId = '', userPhone = '', userCode = '') {
                this.isLoading = true;

                let self = this;
                return new Promise(function(resolve, reject) {
                    self.$http.fetchWithAuthEncrypt`GetUserInfoData${{
                        userId: Number(userId),    //查詢對象的 userId
                        userCode: userCode,     //查詢對象的代號
                        phone: userPhone,     //查詢對象的電話
                    }} ${json => {
                        self.isLoading = false;
                        if (json.status) {
                            try {
                                json.data = self.$crypto.decryptObjectText(json.data)
                            } catch (e) {
                                //
                            }

                            if (json.data.isExist) {
                                self.tmpName = json.data.name;
                                self.tmpPhone = json.data.userCode;
                                self.tmpImg = json.data.picture;       //'https://file.oinapp.com/' +
                                resolve();
                            } else {
                              reject('沒有此會員');
                              self.dialogMsgMain = '請確認號碼輸入是否正確'
                            }
                        } else {
                            reject('沒有轉贈對象的資料');
                        }
                    }}`;
                });
            },
            numberControllerEvent(obj) {
              let self = this;
              let event = obj.event;

              if (event === "returnNumber") {
                self.transAmount = obj.number
              } else if (event === "clickDisabledButton") {
                if(obj.operate === "dec") {
                  this.showDialog('點數不可少於 1 點');
                }
              }
            },
            goBack(){
                if(!this.isWeb){
                    this.$router.go(-1);
                }else {
                    //單店網頁版用
                    this.$emit('close',false);
                }
            },
        },
    }
</script>

<style lang="less" scoped src="../../less/transfer.less"/>